// File: src/BlogList.js
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getBlogList } from "../services/writerBlog";
import { Outlet, useNavigate, useParams } from "react-router";
import { CustomAlert, showToastAlert } from "../admin/components/CustomAlert";
import { Button } from "@mui/material";
import BlogCategory from "./BlogCategory";
import WebsiteBreadCrumb from "./../website/website-components/WebsiteBreadCrumb";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MainHeader from "../components/MainHeader";
import WebsiteFooter from "../website/website-components/WebsiteFooter";
import RecentPosts from "./RecentPosts";
import CustomLoader from "../components/CustomLoader";

const BlogLayout = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [blogList, setBlogList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [loaderOpen, setLoaderOpen] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const response = await getBlogList();
      if (response.status !== 200) {
        showToastAlert(response?.data?.message, "error");
        return;
      }
      setBlogList(response?.data?.blogs || []);
      setCategories(response?.data?.categories || []);
      setRecentPosts(response?.data?.recent || []);
      setLoaderOpen(false);
    } catch (error) {
      console.error("Error loading blogs", error);
      setLoaderOpen(false);
    }
  };

  console.log("blogList", blogList);
  console.log("categories", categories);
  return (
    <>
      <CustomLoader setLoaderOpen={setLoaderOpen} loaderOpen={loaderOpen} />
      <div className="blog-wrapper">
        <MainHeader />
        <div className="container py-5">
          <div className="row">
            <div className="col-sm-9">
              <div className="blog-content-box">
                <Outlet />
              </div>
            </div>
            <div className="col-sm-3">
              <BlogCategory categories={categories} setBlogList={setBlogList} />
              <RecentPosts recentPosts={recentPosts} />
            </div>
          </div>
        </div>

        <WebsiteFooter />
      </div>
    </>
  );
};

export default BlogLayout;
